module.exports = __webpack_public_path__ + "img/wordpress.3ad36c6f.svg";